import React, { useContext } from 'react';
import { LanguageContext } from '../../Data/Context/languageContext';

const SelectDark = ({ classes, options, callBack, selectedValue }) => {
    const { t } = useContext(LanguageContext);

    return (
        <>
            <select className={`form-select bg-dark text-white mb-2 ${classes}`}>
                {options.map((option, index) => {
                    return (
                        <option key={index} onClick={() => callBack(option.value)} value={option.value} >{option.text}</option>
                    );
                })}
            </select>

            {selectedValue &&
                <small> {t("current_version")}: <b>{selectedValue}</b></small>
            }
        </>
    );
}
export default SelectDark;